import { render, staticRenderFns } from "./orderNumber.vue?vue&type=template&id=95ca40d2"
import script from "./orderNumber.vue?vue&type=script&lang=js"
export * from "./orderNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports